import * as React from "react";

interface ContactNumbersProps {
  /** Raw value, one or more numbers separated by "/", "," or ";". */
  value?: string;
  /** Placeholder when empty. Default "-". */
  empty?: string;
}

/**
 * Shows the first contact number plus a "+N" badge when there are more,
 * on a single line. Hovering reveals the full list. Keeps rows compact
 * when a cell holds several numbers.
 */
export default function ContactNumbers({ value, empty = "-" }: ContactNumbersProps) {
  const nums = (value || "")
    .split(/[/,;]/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (nums.length === 0) return <span>{empty}</span>;

  const [first, ...rest] = nums;

  return (
    <div
      title={nums.join("\n")}
      style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
    >
      <span>{first}</span>
      {rest.length > 0 && (
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "var(--ctpl-primary-dark)",
            background: "var(--ctpl-primary-soft)",
            borderRadius: 999,
            padding: "1px 7px",
            cursor: "default",
          }}
        >
          +{rest.length}
        </span>
      )}
    </div>
  );
}